/** Tracks whether partner community chat is actively visible (overview tab). */
let liveViewState = {
  active: false,
  streamChannelId: null,
  gatewayChannelId: null,
};

export const setPartnerCommunityLiveView = (nextState) => {
  liveViewState = {
    active: Boolean(nextState?.active),
    streamChannelId: nextState?.streamChannelId ?? null,
    gatewayChannelId: nextState?.gatewayChannelId ?? null,
  };
};

export const getPartnerCommunityLiveView = () => liveViewState;

export const doesSocketChannelMatchLiveCommunityView = (socketChannelId) => {
  if (!liveViewState.active || !socketChannelId) {
    return false;
  }

  const normalizedSocketId = String(socketChannelId).trim();
  if (!normalizedSocketId) {
    return false;
  }

  const streamChannelId = String(liveViewState.streamChannelId ?? '').trim();
  const gatewayChannelId = String(liveViewState.gatewayChannelId ?? '').trim();

  return (
    normalizedSocketId === streamChannelId ||
    (gatewayChannelId && normalizedSocketId === gatewayChannelId)
  );
};
